import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import moment from "moment"

import { Home } from './Home'
import { About } from './About'

import axios from 'axios'

class App extends Component {

  constructor(props) {
    super(props);

    this.state = { fetched_studies: false, studies: [] }
  }

  componentDidMount() {
    axios.get("/studies.json")
    .then(res => {
      const studies = res.data.map(s => {
        return { ...s, date: moment(s.date, "DD/MM/YYYY") }
      })

      this.setState({ fetched_studies: true, studies: studies })
    })
    .catch(err => {
      console.log(err)
    })
  }

  render() {

    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" render={(props) => 
              <Home {...props} fetched_studies={this.state.fetched_studies} studies={this.state.studies} />
            }/>
            <Route exact path="/study/:key" render={(props) =>
              <Home {...props} fetched_studies={this.state.fetched_studies} studies={this.state.studies} />
            }/>
            <Route exact path="/about" component={About} />
          </Switch>
        </Router>
      </div>
     );
  }
}

export default App;
